import "./contactIntelligence.css"
import ai from "../../../_metronic/images/Ai.svg"
const ContactIntelligenceForReport = ({ data }: any) => {
    if (!data) return null;

    const getSoftColor = (type: string) => {
        switch (type) {
            case "Active":
            case 'Reachable':
            case "Good":
                return "success";
            case 'Unreachable':
            case 'Unknown':
            case "Moderate":
            case "Medium":
                return "warning";
            default:
                return "danger";
        }
    };
    const getLineTypeColor = (type: string) => {
        switch (type) {
            case 'mobile':
                return 'success';
            case 'landline':
                return 'warning';
            case 'nonFixedVoip':
            case 'fixedVoip':
            case 'voip':
                return 'danger';
            default:
                return 'secondary';
        }
    };

    const {
        phone,
        lineType,
        riskLevel,
        status,
        carrierNote
    } = data;

    const headerColor = getLineTypeColor(lineType);
    const riskColor = getSoftColor(riskLevel);
    const statusColor = getSoftColor(status);

    const getCarrierNoteUI = (note: string) => {
        if (!note) {
            return {
                icon: "bi-telephone",
                color: "text-muted",
                status: "unknown"
            };
        }

        const value = note.toLowerCase();

        if (value.includes("standard mobile")) {
            return {
                icon: "bi-phone",
                color: "text-success",
                status: "success"
            };
        }

        if (value.includes("voip") || value.includes("virtual")) {
            return {
                icon: "bi-exclamation-triangle",
                color: "text-warning",
                status: "warning"
            };
        }

        if (value.includes("invalid") || value.includes("disconnected")) {
            return {
                icon: "bi-x-circle",
                color: "text-danger",
                status: "danger"
            };
        }

        return {
            icon: "bi-info-circle",
            color: "text-primary",
            status: "info"
        };
    };
    const carrierUI = getCarrierNoteUI(carrierNote);

    const getInsight = ({ lineType, carrierNote, riskLevel }: any) => {
        const note = carrierNote?.toLowerCase() || "";
        if (
            lineType === "nonFixedVoip" ||
            lineType === "fixedVoip" ||
            note.includes("voip") ||
            note.includes("virtual")
        ) {
            return "Internet-based or temporary phone number detected";
        }

        if (note.includes("invalid") || note.includes("disconnected")) {
            return "Phone number appears invalid or disconnected";
        }

        if (riskLevel === "High") {
            return "High risk number proceed with caution";
        }

        if (lineType === "mobile") {
            return "Standard mobile number safe for communication";
        }
        return null;
    };

    const insightMessage = getInsight({ lineType, carrierNote, riskLevel });

    return (
        <div className="card card-clean shadow-sm h-100">

            <div className="card-header-clean d-flex align-items-center gap-2">
                <i className="bi bi-telephone text-primary"></i>
                Phone Intelligence
            </div>

            <div className="card-body-clean">
                {phone && (
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="fw-semibold fs-5">{phone}</div>
                        <span className={`soft-badge soft-${headerColor}`}>
                            {lineType || "Unknown"}
                        </span>
                    </div>
                )}

                <div className="info-row  p-1">
                    <div className="info-label">
                        <i className="bi bi-diagram-3 text-primary"></i>
                        Line Type
                    </div>
                    <div>{lineType || "-"}</div>
                </div>

                <div className="info-row  p-1">
                    <div className="info-label">
                        <i className="bi bi-shield-exclamation text-warning"></i>
                        Carrier Risk
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <span className={`status-dot status-${riskColor}`}></span>
                        {riskLevel}
                    </div>
                </div>

                <div className="info-row p-1">
                    <div className="info-label">
                        <i className={`bi ${carrierUI.icon} ${carrierUI.color}`}></i>
                        Carrier Name
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <span className={`status-dot status-${carrierUI.status}`}></span>
                        {carrierNote || "Unknown"}
                    </div>
                </div>

                <div className="info-row  p-1">
                    <div className="info-label">
                        <i className="bi bi-check-circle text-success"></i>
                        Status
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <span className={`status-dot status-${statusColor}`}></span>
                        {status}
                    </div>
                </div>
            </div>
            {insightMessage && (
                <div className="insight-box fw-bold gap-0">
                    <img
                        src={ai}
                        alt="ai-icon"
                        className="ai-icon-email-report"
                    />
                    {insightMessage}
                </div>
            )}
        </div>
    );
};

export default ContactIntelligenceForReport;